<template>
    <BlocksAnimation>
        <div
            class="relative grid items-center px-4 text-center before:block after:block lg:px-8"
            :class="{
                'py-36': block?.LinePadding === 'md' || block?.LinePadding === null,
                'py-24': block?.LinePadding === 'sm',
                'py-48': block?.LinePadding === 'lg',
                'grid-cols-[minmax(20px,1fr)_auto_minmax(20px,1fr)]': block?.CentredGraphic.length > 0,
                'grid-cols-2': block?.CentredGraphic.length === 0,
                'gap-8':
                    (block?.SpaceBetween === 'sm' || block?.SpaceBetween === null) && block?.CentredGraphic.length > 0,
                'gap-12': block?.SpaceBetween === 'md' && block?.CentredGraphic.length > 0,
                'gap-16': block?.SpaceBetween === 'lg' && block?.CentredGraphic.length > 0,
                'before:h-px after:h-px': block?.LineWeight === 'sm' || block?.LineWeight === null,
                'before:h-[2px] after:h-[2px]': block?.LineWeight === 'md',
                'before:h-[3px] after:h-[3px]': block?.LineWeight === 'lg',
                'before:bg-(--border-neutral-base) after:bg-(--border-neutral-base)':
                    block?.LineColour === 'base' || block?.LineColour === null,
                'before:bg-(--shape-brand-extra-strong) after:bg-(--shape-brand-extra-strong)':
                    block?.LineColour === 'brand',
                'before:bg-(--shape-brand-accent) after:bg-(--shape-brand-accent)': block?.LineColour === 'accent',
                'before:opacity-75 after:opacity-75': block?.LineOpacity === '75',
                'before:opacity-50 after:opacity-50': block?.LineOpacity === '50',
                'before:opacity-25 after:opacity-25': block?.LineOpacity === '25',
            }"
        >
            <img
                v-if="block?.CentredGraphic.length > 0"
                class="w-auto object-contain"
                :class="{
                    'h-[56px]':
                        (block?.GraphicSize === 'sm' || block?.GraphicSize === null) &&
                        block?.CentredGraphic.length > 0,
                    'h-[72px]': block?.GraphicSize === 'md' && block?.CentredGraphic.length > 0,
                    'h-[88px]': block?.GraphicSize === 'lg' && block?.CentredGraphic.length > 0,
                }"
                :src="block?.CentredGraphic[0].url"
            >
        </div>
    </BlocksAnimation>
</template>

<script setup>
    defineProps({
        id: String,
        block: Object,
    })
</script>
